type Props = {
  className?: string;
};

export const Chat = ({ className }: Props) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.716186 4.04581C0 5.03155 0 6.4377 0 9.25V10.75C0 13.5623 0 14.9684 0.716186 15.9542C0.947485 16.2725 1.22745 16.5525 1.54581 16.7838C2.53155 17.5 3.9377 17.5 6.75 17.5H11.25V19.375C11.25 19.8582 11.7749 20.1587 12.1916 19.9139L16.25 17.5C16.6491 17.2339 16.8487 17.1009 17.0291 16.9642C18.7741 15.6422 19.8543 13.6238 19.9863 11.4386C20 11.2126 20 10.9727 20 10.4931V8.53757C20 6.40191 20 5.33408 19.5778 4.52129C19.222 3.83642 18.6636 3.278 17.9787 2.92223C17.1659 2.5 16.0981 2.5 13.9624 2.5H6.75C3.9377 2.5 2.53155 2.5 1.54581 3.21619C1.22745 3.44748 0.947485 3.72745 0.716186 4.04581ZM2.5 7.1875C2.5 6.66973 2.91973 6.25 3.4375 6.25H10.3125C10.8303 6.25 11.25 6.66973 11.25 7.1875C11.25 7.70527 10.8303 8.125 10.3125 8.125H3.4375C2.91973 8.125 2.5 7.70527 2.5 7.1875ZM3.4375 10.625C2.91973 10.625 2.5 11.0447 2.5 11.5625C2.5 12.0803 2.91973 12.5 3.4375 12.5H6.5625C7.08027 12.5 7.5 12.0803 7.5 11.5625C7.5 11.0447 7.08027 10.625 6.5625 10.625H3.4375Z"
      fill="white"
    />
  </svg>
);
